
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clinic/[id]",
      function () {
        return require("private-next-pages/clinic/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clinic/[id]"])
      });
    }
  